<template>
    <v-form ref="form" style="height: 100%; justify-content: space-between; display: flex; flex-direction: column;">
      <div style="">
        <h5 class="text-center text-24">SMS 본인인증</h5>
        <p class="step-sub-content text-center font-weight-medium">
          회원님의 개인정보보호를 위해
        <br/>
          휴대폰 번호 인증을 실시하고 있습니다.
        </p>
        <br/>
        <!-- 전화번호 입력 폼 -->
        <SMSAuthPhonNumberForm :userData="userData" />

        <p class="step-sub-content text-center">
          입력하신 휴대폰 정보가 정확하지 않을 경우
        <br/>
          인증문자가 발송되지 않습니다.
        </p>
        <p class="step-sub-content text-center">
          2분 이내에 인증문자가 수신되지 않을 경우
        <br/>
          정확한 정보로 재시도 해주시기 바랍니다.
        </p>
        </div>
      <div class="bottom-btn">
         <v-btn color="mainColorDark" x-large depressed block class="mb-3 btn-text-white" :disabled="!isValidPhone || smsBtnDisabled" @click="$emit('startSmsAuthSend')">
          인증번호 받기
        </v-btn>
      </div>
    </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import SMSAuthPhonNumberForm from "./comp/SMSAuthPhonNumberForm.vue";
const rulesService = require("@/utils/rules.js");

export default {
  components: { SMSAuthPhonNumberForm },
  props: {
    userData: {
      type: Object,
    },
    smsAuthStep: Number,
    smsBtnDisabled: Boolean
  },
  computed: {
    isValidPhone() {
      const cellRules = rulesService.cellRules();

      return (
        // 휴대폰번호 유효성 검증
        cellRules.required(this.userData.loginId) === true &&
        cellRules.counter(this.userData.loginId) === true &&
        cellRules.check(this.userData.loginId) === true
      )
    },
    ...mapGetters(["isAuthorized"]),
  },
};
</script>
